import { createUseStyles } from 'react-jss';
import { styled } from '@mui/material/styles';
import { rem } from 'helpers/utils';
import { EFontFamily } from 'helpers/constants';
import { statusBlue, statusGreen, statusOrange } from 'helpers/colors';
import { common } from '@mui/material/colors';

const useStyle = createUseStyles({});

export const PaymentSummaryContainer = styled('div')(() => {
  return {
    borderRadius: `${rem(30)} ${rem(16)} ${rem(16)} ${rem(16)}`,
    border: `1px solid ${statusBlue.border}`,
    width: rem(230),
    color: '#fff',
    opacity: '80%',

    backgroundColor: statusBlue.light,

    '& > div:first-of-type': {
      backgroundColor: statusBlue.main,
      '& p': {
        color: '#fff'
      }
    },

    '& p': {
      color: statusBlue.contrast
    },

    '& svg': {
      marginLeft: 18,
      marginBottom: 5,
      color: '#fff'
    },

    '&.payment-status': {
      backgroundColor: '#FBE9E9',
      border: '1px solid #F1B0B0',

      '& > div:first-of-type': {
        backgroundColor: '#ab3131',
        '& p': {
          color: '#fff'
        }
      },

      '& p': {
        color: '#b95151'
      },

      '& > div:nth-of-type(2)': {
        '& svg': {
          color: '#E77A7A',
          marginTop: 18,
          marginRight: 14
        }
      }
    },

    '&.payment-status-pending': {
      backgroundColor: statusOrange.light,
      border: `1px solid ${statusOrange.border}`,

      '& > div:first-of-type': {
        backgroundColor: statusOrange.main,
        '& p': {
          color: '#fff'
        }
      },

      '& p': {
        color: statusOrange.contrast
      },

      '& > div:nth-of-type(2)': {
        '& svg': {
          color: statusOrange.main,
          marginTop: 18,
          marginRight: 14
        }
      }
    },

    '&.payment-status-concluded': {
      backgroundColor: statusGreen.light,
      border: `1px solid ${statusGreen.border}`,

      '& > div:first-of-type': {
        backgroundColor: statusGreen.main,
        '& p': {
          color: '#fff'
        }
      },

      '& p': {
        color: statusGreen.contrast
      },

      '& > div:nth-of-type(2)': {
        '& svg': {
          color: statusGreen.main,
          marginTop: 18,
          marginRight: 14
        }
      }
    }
  };
});

export const PaymentSummaryContent = styled('div')(() => {
  return {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between'
  };
});

export const PaymentSummaryTitle = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  borderRadius: '0.3rem 0.875rem 0.875rem 0.875rem',
  height: rem(80),

  '& .MuiIconButton-sizeMedium': {
    height: 36,
    width: 37,
    borderRadius: 0,
    marginRight: 5,

    '& svg': {
      marginLeft: 0,
      marginBottom: 0,
      color: '#fff'
    }
  },

  '& .title': {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'column',

    '& p': {
      margin: 0,
      fontFamily: EFontFamily.inter,
      color: common.white,
      fontWeight: 400,
      fontSize: rem(14),
      padding: '0 20px'
    }
  }
}));

export const PaymentSummaryAmount = styled('p')(() => ({
  color: statusBlue.main,
  fontWeight: 400,
  margin: 0,
  padding: '15px 20px',
  fontFamily: EFontFamily.inter,
  fontSize: rem(20)
}));

export default useStyle;
